export default __webpack_public_path__ + "970ac73067a6d651b00fd0fa9ab1fd9f.png";